import { ICurrentUser } from '@api'
import { UseSelectionHook } from '@providers/mapProvider/floorProvider/hooks'
import { IUseSettings } from 'components/NewSettings/hooks/useSettings'
import { cloneDeep } from 'lodash'

export default function SwitchSpacesOptimistically({
  setting,
  user,
  byId,
  selection,
}: {
  setting: IUseSettings
  user: ICurrentUser | null
  byId: any
  selection: UseSelectionHook | undefined
}) {
  const userSpace = user?.space
  const employee = user?.employee
  const oldUserSpace = userSpace
    ? byId[userSpace?.id] || { spaceAssignment: {} }
    : { spaceAssignment: {} }
  const newUserSpace = byId[Object.keys(selection?.items ?? [])?.[0]]

  const updatedSpaces = []

  const switchSpaces =
    oldUserSpace?.spaceAssignment.employee && newUserSpace.spaceAssignment.employee

  const moveToSpace =
    !newUserSpace.spaceAssignment.employee && oldUserSpace?.spaceAssignment.employee

  if (switchSpaces) {
    updatedSpaces.push({
      id: oldUserSpace.id,
      ...oldUserSpace,
      spaceAssignment: cloneDeep(newUserSpace.spaceAssignment),
    })
    updatedSpaces.push({
      id: newUserSpace.id,
      ...newUserSpace,
      spaceAssignment: cloneDeep(oldUserSpace.spaceAssignment),
    })
  } else if (moveToSpace) {
    updatedSpaces.push({
      id: oldUserSpace.id,
      ...oldUserSpace,
      spaceAssignment: {
        employee: null,
        department: setting.unallocateSpaceOnUnseat
          ? null
          : oldUserSpace.spaceAssignment.department,
        team: setting.unallocateSpaceOnUnseat ? null : oldUserSpace.spaceAssignment.team,
      },
    })
    updatedSpaces.push({
      id: newUserSpace.id,
      ...newUserSpace,
      spaceAssignment: cloneDeep(oldUserSpace.spaceAssignment),
    })
  } else {
    updatedSpaces.push({
      id: newUserSpace.id,
      ...newUserSpace,
      spaceAssignment: {
        employee,
        department: employee?.department ?? employee?.dept,
        team: employee?.team,
      },
    })
  }
  return updatedSpaces
}
